export function LilDragonsCountingTabContent() {
  return (
    <div className="mt-10 flex flex-col md:flex-row items-center gap-8">
      <div className="md:w-1/2 flex justify-center">
        <img
          src="/images/dragons/dragon_hey.png"
          alt="Lil' Dragon waving hello"
          className="max-w-[15rem] w-full h-auto"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="md:w-1/2">
        <div className="bg-purple-50 rounded-lg p-4 md:p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-taekwondo-red mb-3">
            Counting to 10 in Korean
          </h3>
          <p className="text-sm text-gray-700 mb-3">
            For our Lil&apos; Dragons, here is a fun way to count in Korean:
          </p>
          <div className="space-y-2 text-sm">
            <div className="flex flex-col sm:flex-row gap-2">
              <div
                className="flex-1 rounded-md px-3 py-2 flex items-center justify-between"
                style={{ backgroundColor: "#85439B", color: "#FFFFFF" }}
              >
                <span className="font-semibold">1</span>
                <span className="font-semibold">하나</span>
                <span className="text-xs md:text-sm">(“HAH-nah”)</span>
              </div>
              <div
                className="flex-1 rounded-md px-3 py-2 flex items-center justify-between"
                style={{ backgroundColor: "#98FD00", color: "#1F2933" }}
              >
                <span className="font-semibold">2</span>
                <span className="font-semibold">둘</span>
                <span className="text-xs md:text-sm">(“DOOL”)</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <div
                className="flex-1 rounded-md px-3 py-2 flex items-center justify-between"
                style={{ backgroundColor: "#85439B", color: "#FFFFFF" }}
              >
                <span className="font-semibold">3</span>
                <span className="font-semibold">셋</span>
                <span className="text-xs md:text-sm">(“SET”)</span>
              </div>
              <div
                className="flex-1 rounded-md px-3 py-2 flex items-center justify-between"
                style={{ backgroundColor: "#98FD00", color: "#1F2933" }}
              >
                <span className="font-semibold">4</span>
                <span className="font-semibold">넷</span>
                <span className="text-xs md:text-sm">(“NET”)</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <div
                className="flex-1 rounded-md px-3 py-2 flex items-center justify-between"
                style={{ backgroundColor: "#85439B", color: "#FFFFFF" }}
              >
                <span className="font-semibold">5</span>
                <span className="font-semibold">다섯</span>
                <span className="text-xs md:text-sm">(“DAH-suht”)</span>
              </div>
              <div
                className="flex-1 rounded-md px-3 py-2 flex items-center justify-between"
                style={{ backgroundColor: "#98FD00", color: "#1F2933" }}
              >
                <span className="font-semibold">6</span>
                <span className="font-semibold">여섯</span>
                <span className="text-xs md:text-sm">(“YUH-suht”)</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <div
                className="flex-1 rounded-md px-3 py-2 flex items-center justify-between"
                style={{ backgroundColor: "#85439B", color: "#FFFFFF" }}
              >
                <span className="font-semibold">7</span>
                <span className="font-semibold">일곱</span>
                <span className="text-xs md:text-sm">(“IL-gop”)</span>
              </div>
              <div
                className="flex-1 rounded-md px-3 py-2 flex items-center justify-between"
                style={{ backgroundColor: "#98FD00", color: "#1F2933" }}
              >
                <span className="font-semibold">8</span>
                <span className="font-semibold">여덟</span>
                <span className="text-xs md:text-sm">(“YOH-duhl”)</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <div
                className="flex-1 rounded-md px-3 py-2 flex items-center justify-between"
                style={{ backgroundColor: "#85439B", color: "#FFFFFF" }}
              >
                <span className="font-semibold">9</span>
                <span className="font-semibold">아홉</span>
                <span className="text-xs md:text-sm">(“AH-hop”)</span>
              </div>
              <div
                className="flex-1 rounded-md px-3 py-2 flex items-center justify-between"
                style={{ backgroundColor: "#98FD00", color: "#1F2933" }}
              >
                <span className="font-semibold">10</span>
                <span className="font-semibold">열</span>
                <span className="text-xs md:text-sm">(“YULL”)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
